import React, { Component } from 'react';
import Header from '../../header/header';
import Aside from '../../aside';
import ApiService from '../../../services/apiService';
import Spinner from '../../spinner';

class PageStatisticTest extends Component {
  apiService = new ApiService();

  state = {
    countStarted: 0,
    countFinished: 0,
    load: true
  };

  componentDidMount() {
    this.updateStatistic();
  }

  updateStatistic = () => {
    this.apiService
      .getQuiz(this.props.match.params.name)
      .then(({ countStarted, countFinished }) => {
        this.setState({
          countStarted,
          countFinished,
          load: false
        });
      });
  };

  render() {
    return (
      <React.Fragment>
        <Header />
        <div className="admin-container">
          {this.state.load ? (
            <Spinner />
          ) : (
            <div className="admin-container__inner">
              Начали тест: {this.state.countStarted} <br />
              Прошли до конца: {this.state.countFinished}
            </div>
          )}
          <Aside />
        </div>
      </React.Fragment>
    );
  }
}

export default PageStatisticTest;
